/**
 * Test usage export. Do not use in your production
 */
export function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@rc-component/portal/es/util.js
// module id = 3543
// module chunks = 0